import React from "react";
import "./About.css";
import SEO from "../../Components/SEO/SEO";
import {
  Clock,
  Phone,
  MapPin,
  Heart,
  Coffee,
  ChefHat,
  Sparkles,
} from "lucide-react";
import { Link } from "react-router-dom";

const VALUES = [
  {
    icon: ChefHat,
    title: "Авторская кухня",
    text: "Старинные рецепты, переосмысленные с современным акцентом.",
  },
  {
    icon: Heart,
    title: "С заботой",
    text: "Каждый гость — друг семьи. Тепло, внимание и комфорт.",
  },
  {
    icon: Coffee,
    title: "Аромат востока",
    text: "Кардамон, корица, шафран — специи, которые вы запомните.",
  },
];

const About = () => {
  return (
    <div className="About fade-in">
      <SEO
        title="О нас — Шахризада"
        description="Узнайте больше о нашем заведении, нашей истории и команде."
        keywords="о нас, Шахризада, история, команда, ресторан"
      />

      <section className="About--Hero">
        <span className="section-eyebrow">
          <Sparkles size={14} /> О нас
        </span>
        <h1 className="About--Title">
          Кафе <em>Шахризада</em>
        </h1>
        <p className="About--Lead">
          «Шахризада» — это оазис восточной культуры и гостеприимства. Мы
          приглашаем вас в кулинарное путешествие, где вековые традиции
          встречаются с современным взглядом на кухню. Каждое блюдо —
          это история, рассказанная через яркие вкусы и пряные ароматы.
        </p>
      </section>

      <section className="About--Values">
        {VALUES.map(({ icon: Icon, title, text }) => (
          <article key={title} className="About--Value">
            <div className="About--ValueIcon">
              <Icon size={22} />
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </section>

      <section className="About--Info">
        <div className="About--InfoCard">
          <div className="About--InfoHead">
            <Clock size={18} />
            <span>Режим работы</span>
          </div>
          <ul className="About--Hours">
            <li>
              <span>Пн – Сб</span>
              <b>9:00 – 21:00</b>
            </li>
            <li>
              <span>Воскресенье</span>
              <b>12:00 – 21:00</b>
            </li>
          </ul>
        </div>

        <div className="About--InfoCard">
          <div className="About--InfoHead">
            <MapPin size={18} />
            <span>Адрес</span>
          </div>
          <p className="About--InfoText">
            г. Олёкминск, ул. Партизанская, д. 1
          </p>
          <p className="About--InfoNote">
            Удобный заезд с центральной улицы, парковка рядом.
          </p>
        </div>

        <div className="About--InfoCard">
          <div className="About--InfoHead">
            <Phone size={18} />
            <span>Контакты</span>
          </div>
          <a className="About--Phone" href="tel:+79248744506">
            +7 (924) 874-45-06
          </a>
          <p className="About--InfoNote">
            Звоните в любое рабочее время — поможем оформить заказ или
            забронировать столик.
          </p>
        </div>
      </section>

      <section className="About--CTA">
        <h2>Голодны? Загляните в меню</h2>
        <p>Сделайте заказ онлайн — самовывоз или доставка по городу.</p>
        <Link to="/" className="accent--button">
          Открыть меню
        </Link>
      </section>
    </div>
  );
};

export default About;
